// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.0732 2.5C16.8966 2.49997 18.3664 2.49995 19.5223 2.65537C20.7225 2.81672 21.733 3.16191 22.5355 3.96447C23.3381 4.76702 23.6833 5.77752 23.8446 6.97767C24.0001 8.13363 24 9.6034 24 11.4269V12.5731C24 14.3966 24.0001 15.8664 23.8446 17.0223C23.6833 18.2225 23.3381 19.233 22.5355 20.0355C21.733 20.8381 20.7225 21.1833 19.5223 21.3446C18.3664 21.5001 16.8966 21.5 15.0731 21.5H8.92687C7.1034 21.5 5.63363 21.5001 4.47767 21.3446C3.27752 21.1833 2.26702 20.8381 1.46447 20.0355C0.661914 19.233 0.316722 18.2225 0.155367 17.0223C-4.64767e-05 15.8664 -2.54319e-05 14.3966 6.74122e-07 12.5732V11.4268C-2.54319e-05 9.60336 -4.64767e-05 8.13361 0.155367 6.97767C0.316722 5.77752 0.661914 4.76702 1.46447 3.96447C2.26702 3.16191 3.27752 2.81672 4.47767 2.65537C5.63362 2.49995 7.10339 2.49997 8.92684 2.5H15.0732ZM16.4986 12.0011L9.30078 7.83203V16.1701L16.4986 12.0011Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-youtube-filled')
export default class LogoYoutubeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-youtube-filled',
    }
  }
}
